import ActiveWorkOrdersTable from './ActiveWorkOrdersTable'

export default ActiveWorkOrdersTable
